import { CheckoutSettings, WhiteLabelInfo } from "./../models/model";
import { Injectable } from "@angular/core";
// import * as cryptoJS from "crypto-js";
import { environment } from "../../../environments/environment";
import { PaymentMethodInfo } from "../models/model";

@Injectable()
export class StorageService {
  encryptKey = environment.encryptKey;

  getAccessToken() {
    let accessTok = sessionStorage.getItem("_a_t");
    return accessTok;
  }

  saveAccessToken(token) {
    sessionStorage.setItem("_a_t", token);
  }

  storePaymentData(checkoutSettings: CheckoutSettings) {
    return sessionStorage.setItem("_p_m_t", JSON.stringify(checkoutSettings));
  }

  getPaymentInfo() {
    return JSON.parse(sessionStorage.getItem("_p_m_t"));
  }

  removePaymentInfo() {
    sessionStorage.removeItem("_p_m_t");
  }

  saveClientId(clientId: string) {
    sessionStorage.setItem("clientId", clientId);
  }

  getClientId(): string {
    return sessionStorage.getItem("clientId");
  }

  saveClientDetails(storeName: string, clientId: string) {
    const clientDetails = {
      storeName,
      clientId,
    };
    localStorage.setItem("store", JSON.stringify(clientDetails));
  }

  getClientDetails() {
    return JSON.parse(localStorage.getItem("store"));
  }

  removeAccessToken() {
    sessionStorage.removeItem("_a_t");
  }

  removeClientDetails() {
    localStorage.removeItem("store");
  }

  saveWhiteLabelInfo(payload: WhiteLabelInfo) {
    return sessionStorage.setItem("w_l_i", JSON.stringify(payload));
  }

  getWhiteLableInfo(): WhiteLabelInfo {
    return JSON.parse(sessionStorage.getItem("w_l_i"));
  }

  saveCustomerName(name: string) {
    sessionStorage.setItem("c_n", JSON.stringify(name));
  }

  getCustomerName(): string {
    return JSON.parse(sessionStorage.getItem("c_n"));
  }

  removeCustomerNameAndWhiteLabelInfo() {
    sessionStorage.removeItem("w_l_i");
    sessionStorage.removeItem("c_n");
    this.removePaymentInfo();
  }

  removeStorage() {
    this.removeClientDetails();
    // this.removeCustomerNameAndWhiteLabelInfo();
    // this.removePaymentInfo();
    // this.removeAccessToken();
  }

  clearStorage() {
    // this.removeAccessToken();
    // this.removePaymentInfo();
  }
}
